// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from "./axios";
import { toast } from "sonner";

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const usePaymentProductStore = create(immer((set) => ({
  paymentProducts: [],

  setPaymentProducts: (paymentProducts) => {
    set((state) => {
      state.paymentProducts = paymentProducts;
    });
  },
  createPaymentProduct: (getToken) => {
    return async (paymentProduct) => {
      try {
        const token = await getToken();
        const { result, status, error } = (await axios.post(`${baseUrl}/paymentProducts`, paymentProduct, createAuthHeader(token))).data;
        // Only treat a saved product (has _id) as success — the API returns
        // status:0 / an empty result when Stripe rejects the request.
        if (error || status !== 1 || !result?._id) {
          toast.error(error || 'Failed to create payment product');
          return;
        }
        toast.success(`Successfully Created`);
        set((state) => {
          state.paymentProducts.push(result);
        });
        return result;
      } catch (error) {
        console.error("Error in createPaymentProduct:", error);
        toast.error(error?.response?.data?.error || 'Failed to create payment product');
      }
    }
  },
  createDonationProduct: (getToken) => {
    return async (paymentProduct) => {
      try {
        const token = await getToken();
        const { result, status, error } = (await axios.post(`${baseUrl}/paymentProducts/donation`, paymentProduct, createAuthHeader(token))).data;
        if (error || status !== 1 || !result?._id) {
          toast.error(error || 'Failed to create donation option');
          return;
        }
        toast.success(`Successfully Created`);
        set((state) => {
          state.paymentProducts.push(result);
        });
        return result;
      } catch (error) {
        console.error("Error in createDonationProduct:", error);
        toast.error(error?.response?.data?.error || 'Failed to create donation option');
      }
    }
  },
  updatePaymentProduct: (getToken) => {
    return async (paymentProduct) => {
      try {
        const token = await getToken();
        const { result, status, error } = (await axios.put(`${baseUrl}/paymentProducts/${paymentProduct._id}`, paymentProduct, createAuthHeader(token))).data;
        // The API 400s (with an error string) when the Stripe leg fails — a
        // success is only a result carrying _id.
        if (error || status !== 1 || !result?._id) {
          toast.error(error || 'Failed to update payment product');
          return;
        }
        toast.success(`Successfully Updated`);
        set((state) => {
          const idx = state.paymentProducts.findIndex((p) => p._id === result._id);
          if (idx !== -1) state.paymentProducts[idx] = { ...state.paymentProducts[idx], ...result };
        });
        return result;
      } catch (error) {
        console.error("Error in updatePaymentProduct:", error);
        toast.error(error?.response?.data?.error || 'Failed to update payment product');
      }
    }
  },
  getPaymentProductUsage: (getToken) => {
    return async (paymentProductId) => {
      try {
        const token = await getToken();
        const { result, error } = (await axios.get(`${baseUrl}/paymentProducts/${paymentProductId}/usage`, createAuthHeader(token))).data;
        if (error) return null;
        return result; // { usedBy: [{type,_id,name}], total }
      } catch (error) {
        console.error("Error in getPaymentProductUsage:", error);
        return null;
      }
    }
  },
  deletePaymentProduct: (getToken) => {
    return async (paymentProduct) => {
      try {
        const token = await getToken();
        const { result, status, error } = (await axios.delete(`${baseUrl}/paymentProducts/${paymentProduct._id}`, createAuthHeader(token))).data;
        error ? toast.error(error) : toast.success(`Successfully Deleted`);
      } catch (error) {
        console.error("Error in deletePaymentProduct:", error);
      }
    }
  },
  getPaymentProductsByLeagueName: (getToken) => {
    return async (leagueName) => {
      try {
        const token = await getToken();
        const { result, status, error } = (await axios.get(`${baseUrl}/paymentProducts/organizationName/${leagueName}`, createAuthHeader(token))).data;
        set((state) => {
          state.paymentProducts = result;
        });
      } catch (error) {
        console.error("Error in getPaymentProductsByLeagueName:", error);
      }
    }
  }
})));

export default usePaymentProductStore;